/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import SuccessActions from '../../containers/SuccessOrderPage/SuccessActions';
import './SuccessOrderPage.sass';

const SuccessOrderPageBody = (props) => {
  const {
    unsuccess,
    formType,
    locationsCountryPath,
    lastOrderEmail,
    cleanOrders,
    selectedLocations,
  } = props;

  const showActions = (formType === 'order');

  let successHeading;
  let successText;

  switch (formType) {
    case 'order':
      successHeading = `${I18n.t('order.success.heading')}`;
      successText = `${I18n.t('order.success.message', { email: lastOrderEmail })}`;
      if (selectedLocations.length > 0) cleanOrders();
      break;
    case 'virtual_office':
      successHeading = `${I18n.t('virtual_office.success.heading')}`;
      successText = `${I18n.t('virtual_office.success.message', { email: lastOrderEmail })}`;
      break;
    case 'sign_up':
      successHeading = `${I18n.t('provider_signup.success.heading')}`;
      successText = `${I18n.t('provider_signup.success.message', { email: lastOrderEmail })}`;
      break;
    case 'about_us':
      successHeading = `${I18n.t('about_us.success.heading')}`;
      successText = `${I18n.t('about_us.success.message', { email: lastOrderEmail })}`;
      break;
    default:
      successHeading = `${I18n.t('order.success.heading')}`;
      successText = `${I18n.t('order.success.message', { email: lastOrderEmail })}`;
  }

  return (
    <div className="thank-you-page__wrapper">
      <div className="thank-you-page__column">
        {unsuccess
          ? (
            <div>
              <h1 className="main-color bold">{I18n.t('order.unsuccess.heading')}</h1>
              <p className="thank-you-page__information">{I18n.t('order.unsuccess.message')}</p>
            </div>
          )
          : (
            <div>
              <h1 className="main-color bold">{successHeading}</h1>
              <p className="thank-you-page__information">{successText}</p>
            </div>
          )
        }
      </div>
      {showActions && (
        <SuccessActions
          locationsCountryPath={locationsCountryPath}
        />
      )}
    </div>
  );
};

SuccessOrderPageBody.propTypes = {
  unsuccess: PropTypes.bool,
  formType: PropTypes.string,
  locationsCountryPath: PropTypes.string,
  lastOrderEmail: PropTypes.string,
  cleanOrders: PropTypes.func,
  selectedLocations: PropTypes.arrayOf(PropTypes.object),
};

SuccessOrderPageBody.defaultProps = {
  unsuccess: false,
  formType: '',
  locationsCountryPath: '',
  lastOrderEmail: '',
  cleanOrders: () => true,
  selectedLocations: [],
};

export default SuccessOrderPageBody;
